import React from "react";
import PresentationLayout2 from "../presentation-layout2";

const Layout = (props) => {
  return (
    <PresentationLayout2>
      {<></>}
      {props.children}
    </PresentationLayout2>
  );
};

export default Layout;
